import { useState } from "react";
import api from "../api/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState(null);
  const [err, setErr] = useState(null);

  const handle = async (e) => {
    e.preventDefault();
    try {
      const res = await api.request("/auth/forgot-password", {
        method: "POST",
        body: JSON.stringify({ email }),
      });
      setMsg(res.message);
      setErr(null);
    } catch (e) {
      setErr(e.message || "Error sending reset email");
      setMsg(null);
    }
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-zinc-900/80 p-8 rounded-xl border border-zinc-700 shadow-xl">

        <h2 className="text-2xl text-yellow-400 font-bold text-center mb-4 uppercase">
          Reset Password
        </h2>

        {msg && <p className="text-green-400 text-sm mb-4">{msg}</p>}
        {err && <p className="text-red-500 text-sm mb-4">{err}</p>}

        <form onSubmit={handle} className="space-y-4">
          <input
            className="w-full px-4 py-3 bg-zinc-800 border border-zinc-700 rounded text-white placeholder-gray-400"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <button className="w-full py-3 bg-yellow-500 hover:bg-yellow-600 text-black font-semibold rounded">
            Send reset link
          </button>
        </form>

      </div>
    </div>
  );
}
